<template>
    <div class="mb-4">
        <label>
            {{ label }}
        </label>
        <input class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" type="text">
    </div>
</template>

<script>

export default {
    props: ['label', 'modelValue'],
    emits: ['update:modelValue'],
}
</script>